export enum ESteps {
  confirm = "confirm",
  success = "success",
  close = "close",
}

export enum ESafemode {
  show = 0,
  hide = 1,
}

export enum ESafeModeStatus {
  undefined = "undefined",
  disabled = "disabled",
  enabled = "enabled",
}
